  <div class="sec-title">
    <h1>Modifier la facture #{{invoiceInfo.invoice_no}}</h1>
  </div>
  <div><a class="btn btn-action" href="/factures" routerLink="/invoices" role="button"><i class="bi bi-arrow-90deg-left"></i> retour aux factures</a></div>
  <div style="width:100%;">
    <div class="alert alert-success p-3"  role="alert" *ngIf="update_message!=''">{{update_message}}</div>
    <form [formGroup]="editInvoiceForm" (ngSubmit)="onSubmit(editInvoiceForm.value, invoiceJobsForm.value, invoicePaymentsForm.value)" novalidate>
      <fieldset class="col-12 float-lg-left form-group mb-3">
        <legend>Info Client/Contrat</legend>
        <div class="fieldset-wrap">
            <div class="float-lg-start col-sm-12 col-lg-5">
              <fieldset [ngClass]="{'client-lg-fr' : clientInfo.client_language_code == 'FR', 'client-lg-en' : clientInfo.client_language_code == 'EN' }">
                <legend class="sub-label">Facturé à:</legend>
                <div class="infobox fieldset-wrap">
                    <div class="float-lg-start col-sm-12 col-lg-6">
                        <div class="mb-2"><a routerLink="/client/{{clientInfo.client_id}}/editer" class="card-link"><button type="button" class="btn btn-outline-secondary action-btn"><i class="bi bi-pencil-square"  data-toggle="tooltip" data-placement="top" title="Modifier le client"></i> modifier le client</button></a></div>
                        <div class="form-group mb-3">
                            <label class="form-label">Client</label>
                            <span *ngIf="clientInfo.client_gender == 'F'; then femme_label else homme_label ">
                            </span>
                            <ng-template #femme_label>
                                (FEMME)
                            </ng-template>
                            <ng-template #homme_label>
                                (HOMME)
                            </ng-template>
                            <span>{{clientInfo.client_fname}} {{clientInfo.client_lname}}</span>
                        </div>

                        <div class="form-group mb-3">
                            <label class="form-label">Adresse principale</label>
                            <span>{{clientInfo.client_address}} {{clientInfo.client_address2}}, {{clientInfo.client_city}}, {{clientInfo.client_province}}, {{clientInfo.client_postalcode}} {{clientInfo.client_country}}</span>
                        </div>

                        <div class="form-group mb-3">
                            <label class="form-label">Langue</label>
                            <span>{{clientInfo.client_language_name}}</span>
                        </div>
                    </div>
                    <div class="float-lg-end col-sm-12 col-lg-6">
                      <div class="form-group mb-2" *ngFor="let contact of clientInfo.contacts">
                          <label class="form-label">{{contact.client_contact_type_name}}</label>
                          <span *ngIf="contact.client_contact_type_id == 4 || contact.client_contact_type_id == 2 || contact.client_contact_type_id == 1; else nolinkdiv">
                              <span *ngIf="contact.client_contact_type_id == 4">
                                  <a href="mailto:{{contact.value}}"><button type="button" class="btn btn-outline-primary btn-contact"><i class="bi bi-envelope-fill"></i></button> {{contact.value || 'N/A'}}</a>
                              </span>
                              <span *ngIf="contact.client_contact_type_id == 1 || contact.client_contact_type_id == 2">
                                  <a href="tel:{{sanitizePhone(contact.value)}}"><button type="button" class="btn btn-outline-primary btn-contact"><i class="bi bi-telephone-fill"></i></button> {{contact.value || 'N/A'}}</a>
                              </span>
                          </span>
                          <ng-template #nolinkdiv>
                              <span>{{contact.value || 'N/A'}}</span>
                          </ng-template>
                      </div>
                   </div>
                </div>
              </fieldset>
            </div>
            <div class="float-lg-end mt-3 col-sm-12 col-lg-6">
              <div class="form-group mb-3">
                <label for="submission_no" class="form-label">Numéro de contrat</label>
                <span>Contrat  #{{submissionInfo.submission_no}}</span>
              </div>
              <div class="form-group mb-3">
                    <label class="form-label">Travaux exécutés au:</label>
                    <span>{{submissionInfo.address}}, {{submissionInfo.city}}, {{submissionInfo.province}} {{submissionInfo.postalcode}}</span>
              </div>  
            </div>
        </div>
    </fieldset>
    <fieldset class="col-12 form-group mb-3">
        <legend>Info Facture</legend>
        <div class="fieldset-wrap">
          <div class="float-lg-end col-sm-12 col-lg-12">
              <div class="float-lg-end mt-3 col-sm-5 col-lg-4">
                <div class="form-group mb-3">
                  <span class="form-label">Numéro de la facture: </span><span class="page_marker_name">#{{invoiceInfo.invoice_no}}</span>
                </div>
                <div class="form-group mb-3">
                  <label class="form-label-inline">Date de création de la facture</label>
                  <input type="text" class="form-control date" name="invoice_created_date" id="invoice_created_date" formControlName="invoice_created_date" />
                </div>
              </div>
          </div>
          <div class="float-start col-12 ">
            <div class="float-start col-7 ">
              <div class="form-group mb-3">
                <div class="form-label">Description</div>
              </div>
            </div>
            <div class="float-start col-4 ">
              <div class="float-start form-group mb-3 ms-3 col-6">
                <div class="form-label">Prix</div>
              </div>
              <div class="float-start form-group mb-3 ms-3 col-3">
                <div class="form-label">Taxable</div>
              </div>
            </div>
            <div class="float-start col-1 ">
              <div class="form-group mb-3">
                <div class="form-label">Retirer</div>
              </div>
            </div>
          </div>
          <div class="float-start col-12 ">
            <div class="form-group mb-3" >
              <div *ngIf="invoiceJobsList.length>0;then email_wrap" ></div>
              <ng-template #email_wrap>
                <div [formGroup]="invoiceJobsForm" *ngFor="let invoiceJob of invoiceJobsList; let i = index;">
                  <div class="float-start col-7">
                    <div class="form-group mb-3">
                      <input type="text" class="form-control" placeholder="la description"  formControlName="invoicejob_description_{{i}}" name="invoicejob_description_{{i}}" id="invoicejob_description_{{i}}" value="{{invoiceJob.description }}" oninput="this.value = this.value.charAt(0).toUpperCase() + this.value.substr(1) " />
                    </div>
                  </div>
                  <div class="float-start col-4">
                    <div class="float-start form-group mb-3 ms-3 col-6">
                      <input href="javascript:void(0);" type="number" class="form-control amount" (change)="onChangeInvoiceJob(i, $event.target)" formControlName="invoicejob_amount_{{i}}" name="invoicejob_amount_{{i}}" id="invoicejob_amount_{{i}}" value="{{invoiceJob.amount}}" />
                    </div>
                    <div class="float-start form-group mb-3 ms-3 col-3">
                      <input type="checkbox" href="javascript:void(0);" (change)="onChangeInvoiceJobTax(i, $event)" class="float-start form-check-input amount active" formControlName="invoicejob_is_taxable_{{i}}" name="invoicejob_is_taxable_{{i}}" id="invoicejob_is_taxable_{{i}}" value="{{invoiceJob.is_taxable}}" checked  />
                      <label for="invoicejob_is_taxable_{{i}}" class="float-start form-check-label d-inline ms-1">Taxe</label>
                      <input type="hidden" class="form-control"  formControlName="invoicejob_tax_federal_{{i}}" name="invoicejob_tax_federal_{{i}}" id="invoicejob_tax_federal_{{i}}" value="{{invoiceJob.tax_federal}}" />
                      <input type="hidden" class="form-control"  formControlName="invoicejob_tax_provincial_{{i}}" name="invoicejob_tax_provincial_{{i}}" id="invoicejob_tax_provincial_{{i}}" value="{{invoiceJob.tax_provincial}}" />
                    </div>
                  </div>
                  <div class="float-start col-1">
                    <div class="form-group mb-3 ms-3 col-12" *ngIf="i>0">
                      <span>
                        <a href="javascript:void(0);" (click)="removeInvoiceJob(i)" role="button" class="btn-delete"><i class="bi bi-file-x-fill"></i></a>
                      </span>
                    </div>
                  </div>
                </div>
              </ng-template>
            </div>
            <div class="float-start col-12 mt-3">

              <div class="col-7 d-flex justify-content-end float-start mb-2 me-3 col-2">
                <div class="form-group">
                  <label class="form-label">Sous-Total</label>
                </div>
              </div>
              <div class="col-4 d-flex justify-content-start float-start mb-2">
                <div class="d-flex justify-content-end float-start form-group ms-5 col-5">
                  <label class="form-label">{{this.orderInfoTotals['invoiceitems_subtotal_count'] | number : '1.2-2'}} $</label>
                </div>
                <div class="d-flex justify-content-end float-start form-group mb-3 me-3 col-6">
                </div>
                <div class="float-start form-group mb-3 ms-3 col-1">
                </div>
              </div>
            </div>
            <div class="float-start col-12">
              <div class="col-7 d-flex justify-content-end float-start mb-2 me-3 col-2">
                <div class="form-group">
                  <label class="form-label">TPS</label>
                </div>
              </div>
              <div class="col-4 d-flex justify-content-start float-start mb-2">
                <div class="d-flex justify-content-end float-start form-group ms-5 col-5">
                  <label class="form-label">{{this.orderInfoTotals['invoiceitems_tps_total_count'] | number : '1.2-2'}} $</label>
                </div>
                <div class="d-flex justify-content-end float-start form-group mb-3 me-3 col-6">
                </div>
                <div class="float-start form-group mb-3 ms-3 col-1">
                </div>
              </div>
            </div>
            <div class="float-start col-12">
              <div class="col-7 d-flex justify-content-end float-start mb-2 me-3 col-2">
                <div class="form-group">
                  <label class="form-label">TVQ</label>
                </div>
              </div>
              <div class="col-4 d-flex justify-content-start float-start mb-2">
                <div class="d-flex justify-content-end float-start form-group ms-5 col-5">
                  <label class="form-label">{{this.orderInfoTotals['invoiceitems_tvq_total_count'] | number : '1.2-2'}} $</label>
                </div>
                <div class="d-flex justify-content-end float-start form-group mb-3 me-3 col-6">
                </div>
                <div class="float-start form-group mb-3 ms-3 col-1">
                </div>
              </div>
            </div>
            <div class="float-start col-12">
              <div class="col-7 d-flex justify-content-end float-start mb-3 me-3 col-2">
                <div class="form-group mb-3">
                  <label class="form-label">Total</label>
                </div>
              </div>
              <div class="col-4 d-flex justify-content-start float-start">
                <div class="d-flex justify-content-end float-start form-group ms-5 col-5">
                  <label class="form-label">{{this.orderInfoTotals['invoiceitems_total_count'] | number : '1.2-2'}} $</label>
                </div>
                <div class="d-flex justify-content-end float-start form-group mb-3 me-3 col-6">
                </div>
                <div class="float-start form-group mb-3 ms-3 col-1">
                </div>
              </div>
            </div>
            <div class="float-start col-12">
              <div class="col-7 d-flex justify-content-end float-start mb-2 me-3 col-2">
                <div class="form-group">
                  <label class="form-label">Total des paiements</label>
                </div>
              </div>
              <div class="col-4 d-flex justify-content-start float-start mb-2">
                <div class="d-flex justify-content-end float-start form-group ms-5 col-5">
                  <label class="form-label">{{this.orderInfoTotals['invoiceitems_total_paiements'] | number : '1.2-2'}} $</label>
                </div>
                <div class="d-flex justify-content-end float-start form-group mb-3 me-3 col-6">
                </div>
                <div class="float-start form-group mb-3 ms-3 col-1">
                </div>
              </div>
            </div>
            <div class="float-start col-12">
              <div class="col-7 d-flex justify-content-end float-start mb-3 me-3 col-2">
                <div class="form-group mb-3">
                  <label class="form-label strong">Montant restant</label>
                </div>
              </div>
              <div class="col-4 d-flex justify-content-start float-start">
                <div class="d-flex justify-content-end float-start form-group ms-5 col-5">
                  <label class="form-label strong">{{this.orderInfoTotals['invoiceitems_total_restant'] | number : '1.2-2'}} $</label>
                </div>
                <div class="d-flex justify-content-end float-start form-group mb-3 me-3 col-6">
                </div>
                <div class="float-start form-group mb-3 ms-3 col-1">
                </div>
              </div>
            </div>
          </div>
          <div class="float-start col-12">
            <div class="form-group mb-3 ms-3">
              <a href="javascript:void(0);" (click)="addInvoiceJob()" role="button"><i class="bi bi-plus-circle-fill btn-add-one"></i><span class="txt-add-one ms-2">Ajouter une description</span></a>
            </div>
          </div>
        </div>
    </fieldset>
    <fieldset class="col-12 form-group mb-3">
      <legend>Paiements</legend>
      <div class="fieldset-wrap">
        <div class="col-12 float-start">
          <div class="float-start col-3">
            <div class="form-group mb-3">
              <label for="first_name" class="form-label">Date</label>
            </div>
          </div>
          <div class="float-start col-5">
            <div class="form-group mb-3 ms-3">
              <label for="last_name" class="form-label">Description	</label>
            </div>
          </div>
          <div class="float-start col-3">
            <div class="form-group mb-3 ms-3 col-9">
              <label for="first_name" class="form-label">Montant</label>
            </div>
          </div>
          <div class="float-start col-1">
            <div class="form-group mb-3 ms-3">
              <label for="gender" class="form-label">Retirer</label>
            </div>
          </div>
        </div>
        <div class="col-12 ">
          <div class="form-group mb-2 col-12" [formGroup]="invoicePaymentsForm" *ngFor="let invoicePayment of invoicePaymentsList; index as i; trackBy:trackByCreated">
            <div class="float-start col-3">
              <div class="form-group mb-3">
                <input type="text" class="form-control flatpickr flatpickr-input datepay"  name="invoicepay_date_{{i}}" id="invoicepay_date_{{i}}" formControlName="invoicepay_date_{{i}}" />
              </div>
            </div>
            <div class="float-start col-5">
              <div class="form-group mb-3 ms-3">
                <input type="text" class="form-control" placeholder="la description" name="invoicepay_description_{{i}}" id="invoicepay_description_{{i}}"  formControlName="invoicepay_description_{{i}}" oninput="this.value = this.value.charAt(0).toUpperCase() + this.value.substr(1) " />
              </div>
            </div>
            <div class="float-start col-3">
              <div class="form-group mb-3 ms-3 col-9">
                <input href="javascript:void(0);" type="number" class="form-control amount" name="invoicepay_amount_{{i}}" id="invoicepay_amount_{{i}}" formControlName="invoicepay_amount_{{i}}" (change)="onChangeInvoicePayAmount(i, $event.target)" />
              </div>
            </div>
            <div class="float-start col-1">
              <div class="form-group mb-3 ms-3 col-12" >
                <span>
                  <a href="javascript:void(0);" (click)="removeInvoicePay(i)" role="button" class="btn-delete"><i class="bi bi-file-x-fill"></i></a>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="float-start col-12">
          <div class="form-group mb-3 ms-3">
            <a href="javascript:void(0);" (click)="addInvoicePay()" role="button"><i class="bi bi-plus-circle-fill btn-add-one"></i><span class="txt-add-one ms-2">Ajouter un paiement</span></a>
          </div>
        </div>
      </div>
    </fieldset> 
    <fieldset class="col-12 form-group mb-3">
      <legend>Imprimer et envoyer</legend>
      <div class="fieldset-wrap">
        <div class="col-12 float-start">
          <div class="float-lg-start col-5">
            <div class="form-group mb-3 ms-3 me-6">
              <label for="first_name" class="form-label">Imprimer</label>
            </div>
            <div class="float-lg-end form-group mb-3 me-5">
              <a (click)="invoicePdf(invoiceInfo.invoice_id, invoiceInfo.invoice_no)"  role="button"><i class="bi bi-file-earmark-pdf-fill btn-add-one"></i><span class="txt-add-one ms-2">Télécharger en PDF</span></a>
            </div>
            <div class="form-group mb-3 ms-3">
              <a (click)="invoicePrint(invoiceInfo.invoice_id, invoiceInfo.invoice_no)"  role="button"><i class="bi bi-printer-fill btn-add-one"></i><span class="txt-add-one ms-2">Imprimer la facture</span></a>
            </div>
            <div class="form-group mb-3 ms-3 col-10">
              <label class="form-label">Date d'envoie (par la poste)</label>
              <div *ngIf="invoiceInfo.sent_postal===false">Pas encore envoyé</div>
              <input type="text" class="form-control date" name="sent_postal_date" id="sent_postal_date" formControlName="sent_postal_date" />
            </div>
          </div>
          <div class="float-lg-start col-3" [formGroup]="invoiceSendForm" >

            <div class="form-group mb-3 ms-3">
              <label class="form-label col-12 mb-3">Envoyer à: </label>
              <div class="col-12">
                  <div *ngFor="let contactType of contactTypeList; let i = index;">
                    <div *ngIf="contactType.client_contact_type_id===4" class="float-lg-start col-sm-12 col-lg-12 mb-1">
                      <li class="list-group-item">
                         <input (change)="onChangeCheckEmail(i, $event)" type="checkbox" class="float-lg-start form-check-input" name="contactTypeSendEmail{{i}}" formControlName="contactTypeSendEmail{{i}}" id="contactTypeSendEmail{{i}}" [checked]="true">
                          <label for="contactTypeSendEmail{{i}}" class="form-check-label d-inline ms-3">{{contactType.value || 'N/A'}}</label>
                      </li>
                    </div>
                  </div>  
              </div>
              <div class="alert alert-success p-1"  role="alert" *ngIf="update_message_email_sent !=''">{{update_message_email_sent}}</div>
            </div>
            <div class="form-group mb-3 ms-3">
              <a (click)="invoiceEmail(invoiceInfo.invoice_id, invoiceInfo.invoice_no, invoiceSendForm.value)" role="button" class="btn_action"><i class="bi bi-envelope-fill btn-add-one"></i><span class="txt-add-one ms-2">Envoyer la facture par courriel</span></a>
            </div>
          </div>
          <div class="float-lg-start col-3"> 
            <div class="form-group mb-3 ms-3 col-12">
              
              <div class="col-12">
                <div class="">
                  <label class="form-label">Date du dernier envoie: </label>
                </div>
                <div class="">
                  <div *ngIf="invoiceInfo.sent_email==true; else blockNotSent">{{invoiceInfo.sent_email_date || 'N/A'}}</div>
                  <ng-template #blockNotSent>Pas encore envoyé</ng-template>
                </div>
              </div>
              <div class="mt-3">
                <label class="form-label">Historique:</label>
              </div>
              <div class="col-12 container-invoice overflow-auto"  *ngIf="invoiceInfo.sent_email==true;">
               
                <div class="" *ngFor="let emailHistoricDate of invoiceHistory; let i = index;">
                  <div *ngIf="i != 0">{{emailHistoricDate.sent_email_date || 'N/A'}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </fieldset>
    <fieldset class="col-12 form-group mb-3">
      <legend>Statut de la facture</legend>
      <div class="fieldset-wrap">
        <div class="col-12 float-start">
          <div class="float-lg-start col-6">
            <div class="form-group mb-3 ms-3">
              <p>Défini le status de la facture.</p>
              <p>Si le statut de la facture est annulé la facture n'apparaitera pas dans les rapports.</p>
            </div>
            <div class="form-group mb-3 ms-3 col-6">
              <select class="form-select col-lg-3" name="status" id="status" formControlName="status">
                <option [selected]="invoiceInfo.active === true" [value]="true" > Valide </option>
                <option [selected]="invoiceInfo.active === false" [value]="false" > Annulé </option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </fieldset>
    <div class="mb-3 mt-2">
      <span class="sub-label">Date de création :</span> {{invoiceInfo.created | date:'medium'}}<br/>
      <span class="sub-label">Dernière mise à jour :</span> {{invoiceInfo.updated  | date:'medium'}}  - <span class="sub-label">par : </span>{{invoiceInfo.created_by_fname}} {{invoiceInfo.created_by_lname}} 
    </div>
    <button type="submit" class="btn btn-primary">Enregistrer</button>
  </form>
</div>
<hr/>
<div id="print-section"></div>